<template>
  <div class="dashboard-page">
    <div class="page-header">
      <h1>愿毕达规划师系统 - 仪表盘</h1>
      <div style="display: flex; gap: 10px; height: 100%;align-items: top;">
        <!-- 使用Vuex的isSuperAdmin状态，检查是否为管理员 -->
        <button v-if="isSuperAdmin === '超级管理员' || isSuperAdmin === '管理员'" 
        class="auth-btn" 
        style="background-color: #ff6b35; color: white;" 
        @click="goToAdmin">
          管理员后台<br>
          (权限: {{ isSuperAdmin }})
        </button>
        <button class="auth-btn" @click="goToSearch">首页</button>
        <button class="auth-btn majors-btn" @click="goToMajors" style="background-color: #409EFF; color: white;">院校库专业库</button>
        

        <!-- 消息和问题反馈按钮组 -->
        <div class="message-feedback-group" style="display: flex; flex-direction: column; gap: 5px; width: 80px;">
          <!-- 消息通知按钮 -->
          <button class="auth-btn message-btn" style="background-color: #2196F3; position: relative; width: 100%; height: 32px; padding: 6px 12px; margin: 0; box-sizing: border-box; line-height: 1.2;" @click="showMessageModal = true">
            消息
            <span v-if="unreadMessageCount > 0" class="message-badge">{{ unreadMessageCount }}</span>
          </button>

          <!-- 问题反馈按钮 -->
          <button class="auth-btn feedback-btn" style="background-color: #ff9800; width: 100%; height: 32px; padding: 6px 12px; margin: 0; box-sizing: border-box; line-height: 1.2;" @click="showFeedbackModal = true">问题反馈</button>
        </div>

        <!-- 使用Vuex的isLoggedIn和username状态 -->
        <div v-if="isLoggedIn" class="user-auth-group" style="display: flex; flex-direction: column; gap: 5px; width: 80px;">
          <button class="username auth-btn" style="height: 32px; padding: 6px 12px; margin: 0; box-sizing: border-box; line-height: 1.2; position: relative;">
            {{ username }}
            <!-- 用户身份角标：优先级 超级管理员 > 管理员 > 规划师 > VIP -->
            <span v-if="userVipInfo || isSuperAdmin === '超级管理员' || isSuperAdmin === '管理员'" class="user-badge">
              <template v-if="isSuperAdmin === '超级管理员'">S管理员</template>
              <template v-else-if="isSuperAdmin === '管理员' || (userVipInfo && userVipInfo.is_admin == true)">管理员</template>
              <template v-else-if="userVipInfo && userVipInfo.is_svip == true">规划师</template>
              <template v-else-if="userVipInfo && userVipInfo.is_vip == true">VIP</template>
            </span>
          </button>
          <button class="auth-btn" style="height: 32px; padding: 6px 12px; margin: 0; box-sizing: border-box; line-height: 1.2;" @click="logout">退出登录</button>
        </div>
        <div v-else class="user-auth-group" style="display: flex; flex-direction: column; gap: 5px; width: 80px;">
          <button class="auth-btn" style="height: 32px; padding: 6px 12px; margin: 0; box-sizing: border-box; line-height: 1.2;" @click="goToLogin">登录</button>
          <button class="auth-btn" style="height: 32px; padding: 6px 12px; margin: 0; box-sizing: border-box; line-height: 1.2;" @click="goToRegister">注册</button>
        </div>
      </div>
    </div>

    <div class="dashboard-content">
      <!-- 新增会员卡激活卡片 - 仅普通用户显示 -->
      <div class="quick-actions" v-if="!['管理员', '超级管理员'].includes(isSuperAdmin)">
        <div class="card-header">
          <h2>会员卡激活</h2>
        </div>
        <div class="card-content">
          <!-- 高考年份显示 - 放在最上面 -->
          <div class="gaokao-year-section" v-if="isGaokaoYearSet" style="display: flex; align-items: center; justify-content: center; gap: 20px; margin-bottom: 15px;">
            <div class="gaokao-year-display">
              <label>高考年份：</label>
              <span>{{ gaokaoYear }}年</span>
            </div>
          </div>
          
          <!-- 统一的卡密激活区域 -->
          <div class="activation-section">
            <input type="text" v-model="cardNumber" placeholder="请输入卡密" class="card-input">
            <button class="btn btn-activate" @click="activateCard">激活</button>
          </div>
          
          <!-- VIP、规划师和管理员状态显示 - 优先级：管理员 > 规划师 > VIP -->
          <div v-if="userVipInfo" class="vip-info">
            <!-- 管理员卡优先显示 -->
            <p v-if="userVipInfo.is_admin">
              管理员已激活（有效期至: {{ formatDate(userVipInfo.admin_expire_date) }}，剩余 {{ userVipInfo.admin_remaining_days }}天）
            </p>
            <!-- 没有管理员卡，显示规划师卡 -->
            <p v-else-if="userVipInfo.is_svip">
              规划师已激活（有效期至: {{ formatDate(userVipInfo.svip_expire_date) }}，剩余 {{ userVipInfo.svip_remaining_days }}天）
            </p>
            <!-- 没有管理员卡和规划师卡，显示VIP卡 -->
            <p v-else-if="userVipInfo.is_vip">
              VIP已激活（有效期至: {{ formatDate(userVipInfo.vip_expire_date) }}，剩余 {{ userVipInfo.remaining_days }}天）
            </p>
            <!-- 都没有显示未激活 -->
            <p v-else>VIP未激活</p>
          </div>
        </div>
      </div>
     

      <!-- 新增功能2: 快捷操作区域 -->
      <div class="quick-actions">
        <h2>快捷操作</h2>
        <div class="action-buttons">
            <!-- 添加霍兰德职业测评按钮到快捷操作区域 -->
          <button class="action-btn" @click="goToHollandTest">霍兰德职业测评</button>
          <button class="action-btn" @click="goToSearch">首页</button>
          <button class="action-btn" @click="goToMajors" style="background-color: #409EFF; color: white;">院校库专业库</button>
          <button class="action-btn vip-btn" @click="goToWishlistHistory" style="position: relative;">
            我的志愿记录
            <span class="vip-badge">VIP</span>
          </button>
          <button class="action-btn" v-if="isSuperAdmin === '超级管理员'" @click="goToAnalytics">数据分析</button>
          <button class="action-btn" v-if="isSuperAdmin === '超级管理员'" @click="goToSettings">系统设置</button>
          <button class="action-btn" @click="showChangePasswordModal = true">修改密码</button>

        </div>
      </div>
       <!-- 新增功能1: 数据概览卡片 - 仅超级管理员可见 -->
       <div class="dashboard-cards" v-if="isSuperAdmin === '超级管理员'">
        <div class="card">
          <div class="card-header">
            <h3>学校数量</h3>
          </div>
          <div class="card-content">
            <div class="card-value">{{ schoolCount }}</div>
            <div class="card-description">系统中收录的学校总数</div>
          </div>
        </div>
        
        <div class="card">
          <div class="card-header">
            <h3>专业数量</h3>
          </div>
          <div class="card-content">
            <div class="card-value">{{ majorCount }}</div>
            <div class="card-description">系统中收录的专业总数</div>
          </div>
        </div>
        
        <div class="card">
          <div class="card-header">
            <h3>最新数据年份</h3>
          </div>
          <div class="card-content">
            <div class="card-value">{{ lastUpdate }}</div>
            <div class="card-description">系统最新录取数据年份</div>
          </div>
        </div>
        
        <div class="card">
          <div class="card-header">
            <h3>用户统计</h3>
          </div>
          <div class="card-content">
            <div class="card-value">{{ displayUserCount }}</div>
            <div class="card-description">当前登录用户数</div>
          </div>
        </div>
      </div>
      <!-- 新增功能3: 最近查询记录 - 仅超级管理员可见 -->
      <div class="recent-searches" v-if="isSuperAdmin === '超级管理员'">
        <h2>最近查询记录</h2>
        <div v-if="recentSearches.length === 0" class="no-data">暂无查询记录</div>
        <div v-else class="search-list">
          <div v-for="(search, index) in recentSearches" :key="index" class="search-item">
            <div class="search-info">
              <span class="search-date">{{ search.date }}</span>
              <span class="search-keyword">{{ search.keyword }}</span>
            </div>
            <button class="search-btn" @click="repeatSearch(search)">重复查询</button>
          </div>
        </div>
      </div>

      <!-- 新增功能4: 热门专业推荐 - 仅超级管理员可见 -->
      <div class="popular-majors" v-if="isSuperAdmin === '超级管理员'">
        <h2>热门专业推荐</h2>
        <div class="major-list">
          <div v-for="(major, index) in popularMajors" :key="index" class="major-item">
            <div class="major-name">{{ major.name }}</div>
            <div class="major-rank">{{ major.rank }}</div>
          </div>
        </div>
      </div>
      
    </div>

    <!-- 修改密码弹窗 -->
    <div v-if="showChangePasswordModal" class="modal-overlay" @click.self="showChangePasswordModal = false">
      <div class="modal-container">
        <h3>修改登录密码</h3>
        <p class="modal-desc">设置密码后，您可以使用手机号和密码登录</p>
        <div class="form-group">
          <label>新密码 <span style="color: red;">*</span></label>
          <input 
            type="password" 
            v-model="newPassword" 
            placeholder="请设置6位以上密码" 
            class="form-input"
            minlength="6">
        </div>
        <div class="form-group">
          <label>确认密码 <span style="color: red;">*</span></label>
          <input 
            type="password" 
            v-model="confirmNewPassword" 
            placeholder="请再次输入密码" 
            class="form-input"
            minlength="6">
        </div>
        <div class="modal-buttons">
          <button type="button" class="btn-cancel" @click="showChangePasswordModal = false">取消</button>
          <button type="button" class="btn-confirm" @click="submitChangePassword">确认设置</button>
        </div>
      </div>
    </div>

    <footer class="footer">
      <div class="footer-content">
        <p>版权所有 © {{ currentYear }} 愿毕达所有</p>
        <p>数据仅供参考，以官方公布为准</p>
      </div>
    </footer>

    <!-- 消息通知弹窗 -->
    <div v-if="showMessageModal" class="modal-overlay" @click.self="closeMessageModal">
      <div class="message-modal-container">
        <div class="modal-header" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
          <h3>消息通知</h3>
          <button class="close-btn" @click="closeMessageModal" style="background: none; border: none; font-size: 20px; cursor: pointer;">×</button>
        </div>
        
        <!-- 消息列表 -->
        <div class="message-list" style="max-height: 60vh; overflow-y: auto;">
          <div v-if="messageList.length === 0" class="no-message" style="text-align: center; color: #999; padding: 40px;">
            暂无消息
          </div>
          
          <div v-for="msg in messageList" :key="msg.id" 
               class="message-item" 
               :class="{ unread: !msg.is_read }"
               style="padding: 15px; border-bottom: 1px solid #eee; cursor: pointer;"
               @click="readMessage(msg)">
            <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
              <span style="font-weight: bold; color: #333;">{{ msg.title }}</span>
              <span style="color: #999; font-size: 12px;">{{ msg.created_at }}</span>
            </div>
            <div style="color: #666; font-size: 14px; line-height: 1.5; white-space: pre-wrap;">{{ msg.content }}</div>
            <div v-if="!msg.is_read" style="margin-top: 5px;">
              <span style="color: #f44336; font-size: 12px;">未读</span>
            </div>
          </div>
        </div>
        
        <!-- 操作按钮 -->
        <div class="modal-buttons" style="margin-top: 15px; display: flex; justify-content: space-between;">
          <button type="button" class="btn-cancel" @click="closeMessageModal">关闭</button>
          <button v-if="unreadMessageCount > 0" type="button" class="btn-confirm" @click="markAllMessagesRead">全部已读</button>
        </div>
      </div>
    </div>

    <!-- 问题反馈弹窗 -->
    <div v-if="showFeedbackModal" class="modal-overlay" @click.self="closeFeedbackModal">
      <div class="feedback-modal-container">
        <h3>问题反馈</h3>
        <p class="modal-desc">请描述您遇到的问题或建议，我们会尽快处理</p>
        <div class="feedback-form">
          <div class="feedback-form-item">
            <label class="feedback-label">反馈内容 <span class="required">*</span></label>
            <textarea 
              v-model="feedbackContent" 
              placeholder="请详细描述您遇到的问题..." 
              class="feedback-textarea"
              rows="4"></textarea>
          </div>
          <!-- 图片上传区域 -->
          <div class="feedback-form-item">
            <label class="feedback-label">截图<span class="optional">（选填，支持粘贴图片）</span></label>
            <div class="image-upload-wrapper">
              <div 
                class="image-upload-area"
                @paste="handleFeedbackPaste"
                tabindex="0"
                ref="feedbackImageArea"
              >
                <div v-if="feedbackImages.length === 0" class="upload-placeholder">
                  <p>点击此处后按 Ctrl+V 粘贴截图</p>
                  <p style="font-size: 12px; color: #999;">或直接将图片粘贴到此处</p>
                </div>
                <div v-else class="image-preview-list">
                  <div v-for="(img, index) in feedbackImages" :key="index" class="image-preview-item">
                    <img :src="img" alt="反馈图片" @click="previewFeedbackImage(img)">
                    <button type="button" class="remove-image-btn" @click="removeFeedbackImage(index)">×</button>
                  </div>
                  <div v-if="feedbackImages.length < 5" class="add-more-images" @click="focusImageArea">
                    <span>+</span>
                    <p>继续粘贴</p>
                  </div>
                </div>
              </div>
              <input
                type="file"
                ref="feedbackFileInput"
                accept="image/*"
                multiple
                style="display: none;"
                @change="handleFeedbackFileSelect"
              />
              <button type="button" class="upload-image-btn" @click="triggerFeedbackFileInput">
                <span>📁</span>
                <span>上传图片</span>
              </button>
            </div>
            <p v-if="feedbackImages.length > 0" class="image-count-hint">
              已添加 {{ feedbackImages.length }} 张图片，最多5张
            </p>
          </div>
          <div class="feedback-form-item">
            <label class="feedback-label">联系方式<span class="optional">（选填）</span></label>
            <input 
              type="text" 
              v-model="feedbackContact" 
              placeholder="手机号/邮箱/微信，方便我们联系您" 
              class="feedback-input">
          </div>
        </div>
        <div class="feedback-modal-buttons">
          <button type="button" class="feedback-btn-cancel" @click="closeFeedbackModal">取消</button>
          <button type="button" class="feedback-btn-confirm" @click="submitFeedback" :disabled="isSubmittingFeedback">
            {{ isSubmittingFeedback ? '提交中...' : '提交反馈' }}
          </button>
        </div>
      </div>
    </div>
    
    <!-- 图片预览弹窗 -->
    <div v-if="previewImageUrl" class="modal-overlay" @click.self="previewImageUrl = null">
      <div class="modal-container" style="max-width: 90vw; max-height: 90vh; padding: 10px;">
        <img :src="previewImageUrl" style="max-width: 100%; max-height: 85vh; display: block; margin: 0 auto;">
        <div class="modal-buttons" style="margin-top: 10px;">
          <button type="button" class="btn-cancel" @click="previewImageUrl = null">关闭</button>
        </div>
      </div>
    </div>

    </div>
</template>

<script>
import axios from 'axios';
import { mapState, mapActions } from 'vuex';  // 导入Vuex辅助函数
// import { getCookie } from '@/utils'
export default {
  name: 'Dashboard',
  data() {
    return {
      // 初始化数据
      schoolCount: 0,
      majorCount: 0,
      lastUpdate: '', // 修复：添加缺失的属性
      userCount: 0,   // 修复：添加缺失的属性
      displayUserCount: 0, // 用于显示的用户数（动态增长）
      userCountInterval: null, // 用户数增长定时器
      recentSearches: [],
      popularMajors: [],
      cardNumber: '',
      userVipInfo: null,
      query: '/',
      // 智能轮询相关变量
      loginStatusInterval: null,
      userActivityTimeout: null,
      isUserActive: true,
      lastActivityTime: Date.now(),
      POLLING_INTERVAL_ACTIVE: 30000,
      POLLING_INTERVAL_IDLE: 120000,
      IDLE_TIMEOUT: 120000,
      // 高考年份
      gaokaoYear: '',
      availableYears: [],
      isGaokaoYearSet: false,
      // 姓名编辑
      editFirstname: '',
      // 修改密码弹窗
      showChangePasswordModal: false,
      newPassword: '',
      confirmNewPassword: '',
      // 消息通知
      showMessageModal: false,
      messageList: [],
      unreadMessageCount: 0,
      messagePollingInterval: null,
      // 问题反馈弹窗
      showFeedbackModal: false,
      feedbackContent: '',
      feedbackContact: '',
      isSubmittingFeedback: false,
      feedbackImages: [],
      previewImageUrl: null
      // 移除：isSuperAdmin, isLoggedIn, username（这些现在从Vuex获取）
    };
  },
  
  // 生命周期钩子：mounted 应该在组件根级别，而不是在 methods 内部
  mounted() {
    this.loadVipInfo();
    this.loadDashboardData();
    // 初始化姓名输入框
    this.editFirstname = this.firstname;
    // 启动消息轮询
    if (this.isLoggedIn) {
      this.startMessagePolling();
    }
    // 调用Vuex的checkLoginStatus action
    this.checkLoginStatus().catch(error => {
      if (error.message === 'KICKED_OUT') {
        const deviceType = error.kickedOutInfo?.device_type || '其他设备';
        const kickedTime = error.kickedOutInfo?.kicked_at || '';
        this.$message.warning(
          `您的账号已在${deviceType}上登录，您已被踢出。\n登录时间：${kickedTime}`,
          5000
        );
        this.$router.push('/login');
      }
    });
    // 启动登录状态轮询
    this.startLoginStatusPolling();
    // 添加调试日志
    // console.log('当前用户权限:', this.isSuperAdmin);
    // console.log('登录状态:', this.isLoggedIn);
    // console.log('用户名:', this.username);
  },
  beforeDestroy() {
    // 组件销毁时停止轮询
    this.stopLoginStatusPolling();
    // 停止消息轮询
    this.stopMessagePolling();
    // 停止用户数增长定时器
    if (this.userCountInterval) {
      clearTimeout(this.userCountInterval);
    }
  },
  
  // 计算属性：从Vuex获取状态
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
      username: state => state.user.displayName || state.user.username,
      firstname: state => state.user.firstname,
      isSuperAdmin: state => state.user.isSuperAdmin,
      isStaff: state => state.user.isStaff,
      role: state => state.user.role
    }),
    isAdmin() {
      // 检查是否是管理员或超级管理员（包括通过VIP卡激活的管理员）
      return this.isSuperAdmin === '超级管理员' || this.isSuperAdmin === '管理员' ||
             this.isSuperAdmin === true || (this.userVipInfo && this.userVipInfo.is_admin);
    },
    currentYear() {
      return new Date().getFullYear();
    }
  },
  
  // 监听器
  watch: {
    isSuperAdmin(newVal) {
      console.log('isSuperAdmin 变化为:', newVal);
    },
    firstname(newVal) {
      // 当Vuex中的firstname变化时，同步到编辑框
      this.editFirstname = newVal || '';
    }
  },
  
  // 方法
  methods: {
    // 从Vuex获取action
    ...mapActions(['checkLoginStatus', 'logout']),

    // 启动登录状态轮询（智能轮询）
    startLoginStatusPolling() {
      this.stopLoginStatusPolling();
      this.startUserActivityMonitoring();
      this.scheduleNextPoll();
    },

    // 调度下一次轮询
    scheduleNextPoll() {
      if (this.loginStatusInterval) {
        clearTimeout(this.loginStatusInterval);
        this.loginStatusInterval = null;
      }
      const interval = this.isUserActive ? this.POLLING_INTERVAL_ACTIVE : this.POLLING_INTERVAL_IDLE;
      this.loginStatusInterval = setTimeout(() => {
        if (this.isLoggedIn) {
          this.checkLoginStatus().catch(error => {
            if (error.message === 'KICKED_OUT') {
              const deviceType = error.kickedOutInfo?.device_type || '其他设备';
              const kickedTime = error.kickedOutInfo?.kicked_at || '';
              this.$message.warning(
                `您的账号已在${deviceType}上登录，您已被踢出。\n登录时间：${kickedTime}`,
                5000
              );
              this.$router.push('/login');
            }
          }).finally(() => {
            this.scheduleNextPoll();
          });
        }
      }, interval);
    },

    // 停止登录状态轮询
    stopLoginStatusPolling() {
      if (this.loginStatusInterval) {
        clearTimeout(this.loginStatusInterval);
        this.loginStatusInterval = null;
      }
      this.stopUserActivityMonitoring();
    },

    // 启动用户活动监听
    startUserActivityMonitoring() {
      this.lastActivityTime = Date.now();
      this.isUserActive = true;
      const activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'];
      this.handleUserActivity = () => {
        const wasIdle = !this.isUserActive;
        this.lastActivityTime = Date.now();
        this.isUserActive = true;
        if (wasIdle) {
          this.scheduleNextPoll();
        }
        this.resetIdleTimeout();
      };
      activityEvents.forEach(event => {
        document.addEventListener(event, this.handleUserActivity, true);
      });
      this.resetIdleTimeout();
    },

    // 停止用户活动监听
    stopUserActivityMonitoring() {
      if (this.handleUserActivity) {
        const activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'];
        activityEvents.forEach(event => {
          document.removeEventListener(event, this.handleUserActivity, true);
        });
        this.handleUserActivity = null;
      }
      if (this.userActivityTimeout) {
        clearTimeout(this.userActivityTimeout);
        this.userActivityTimeout = null;
      }
    },

    // 重置空闲检测定时器
    resetIdleTimeout() {
      if (this.userActivityTimeout) {
        clearTimeout(this.userActivityTimeout);
      }
      this.userActivityTimeout = setTimeout(() => {
        const idleTime = Date.now() - this.lastActivityTime;
        if (idleTime >= this.IDLE_TIMEOUT) {
          this.isUserActive = false;
          this.scheduleNextPoll();
        }
      }, this.IDLE_TIMEOUT);
    },

    // 激活会员卡
    activateCard() {
      if (!this.cardNumber) {
        alert('请输入会员卡卡密');
        return;
      }
      
      // const csrftoken = getCookie('csrftoken');
      axios.post('api/activate-card/', {
        card_number: this.cardNumber.trim()
      }, {
        // withCredentials: true,
        // headers: { 'X-Csrftoken': csrftoken },
        // credentials: 'include'  // 确保发送cookie
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-Csrftoken',
      })
      .then(response => {
        if (response.data.success) {
          alert(response.data.message);
          this.cardNumber = '';
          this.loadVipInfo();
        } else {
          alert(response.data.message);
        }
      })
      .catch(error => {
        let errorMessage = '激活失败';
        if (error.response) {
          errorMessage = error.response.data.message || error.response.data.error || errorMessage;
        } else if (error.request) {
          errorMessage = '服务器无响应，请稍后重试';
        } else {
          errorMessage = '请求错误: ' + error.message;
        }
        alert(errorMessage);
        console.error('激活会员卡错误:', error);
      });
    },
    

    
    // 加载用户VIP信息
    loadVipInfo() {
      // const csrftoken = getCookie('csrftoken');
      axios.get('api/vip-info/',{
        // withCredentials: true,
        // headers: {
        //   'X-Csrftoken': csrftoken
        // },
        // credentials: 'include'
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-Csrftoken',
      })
        .then(response => {
          this.userVipInfo = response.data;
          // 同时加载高考年份
          this.loadGaokaoYear();
        })
        .catch(error => {
          console.error('加载VIP信息失败:', error);
        });
    },

    // 加载高考年份
    loadGaokaoYear() {
      if (!this.isLoggedIn) {
        this.gaokaoYear = '';
        this.isGaokaoYearSet = false;
        return;
      }

      axios.get('api/user-gaokao-year/', {
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-Csrftoken',
      })
        .then(response => {
          this.gaokaoYear = response.data.gaokao_year || '';
          // 使用后端返回的标志，如果不存在则根据 gaokao_year 判断
          this.isGaokaoYearSet = response.data.is_gaokao_year_set !== undefined 
            ? response.data.is_gaokao_year_set 
            : (response.data.gaokao_year !== null && response.data.gaokao_year !== '');
        })
        .catch(error => {
          console.error('加载高考年份失败:', error);
        });
    },




    
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString();
    },
    
    // 加载仪表盘数据
    loadDashboardData() {
      // 未登录不调用API
      if (!this.isLoggedIn) {
        this.schoolCount = 0;
        this.majorCount = 0;
        this.userCount = 0;
        this.displayUserCount = 0;
        return;
      }
      
      // 从后端API获取真实数据
      axios.get('api/admin/dashboard/', {
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-Csrftoken',
      })
      .then(response => {
        if (response.data.success) {
          this.schoolCount = response.data.school_count || 0;
          this.majorCount = response.data.major_count || 0;
          this.lastUpdate = response.data.last_update || '暂无数据';
          this.userCount = response.data.user_count || 0;
          this.displayUserCount = this.userCount;
          // 启动用户数动态增长
          this.startUserCountGrowth();
        }
      })
      .catch(error => {
        console.error('加载仪表盘数据失败:', error);
        // 加载失败时使用默认数据
        this.schoolCount = 0;
        this.majorCount = 0;
        this.lastUpdate = '暂无数据';
        this.userCount = 0;
        this.displayUserCount = 0;
      });

      // 生成可用年份列表（当前年份到未来5年）
      const currentYear = new Date().getFullYear();
      this.availableYears = [];
      const startYear = currentYear;
      const endYear = currentYear + 5;
      
      // 生成从startYear到endYear的年份列表
      for (let year = startYear; year <= endYear; year++) {
        this.availableYears.push(year);
      }

      // 模拟最近查询记录
      this.recentSearches = [
        { date: '2025-01-20', keyword: '计算机科学与技术' },
        { date: '2025-01-18', keyword: '北京大学' },
        { date: '2025-01-15', keyword: '人工智能' }
      ];

      // 模拟热门专业推荐
      this.popularMajors = [
        { name: '计算机科学与技术', rank: '1' },
        { name: '人工智能', rank: '2' },
        { name: '数据科学与大数据技术', rank: '3' },
        { name: '临床医学', rank: '4' },
        { name: '金融学', rank: '5' }
      ];
    },
    
    // 快捷导航方法
    goToHollandTest() {
      this.$router.push('/holland-test');
    },
    goToSearch() {
      this.$router.push('/');
    },
    openLocalServer() {
      // 打开本地前端服务器
      window.open('http://localhost:8080', '_blank');
    },
    goToWishlistHistory() {
      // 检查是否有VIP权限
      const hasVipAccess = this.userVipInfo && (this.userVipInfo.is_vip || this.userVipInfo.is_svip || this.userVipInfo.is_admin);
      const isAdmin = this.isSuperAdmin === '超级管理员' || this.isSuperAdmin === '管理员' || (this.userVipInfo && this.userVipInfo.is_admin);

      if (!hasVipAccess && !isAdmin) {
        this.$message.warning('该功能需要VIP权限，请先激活VIP卡');
        return;
      }
      
      // 使用localStorage传递信息，直接跳转
      localStorage.setItem('openWishlistHistory', 'true');
      this.$router.push('/');
    },
    goToMajors() {
      this.$router.push('/majors');
    },
    goToWishlist() {
      this.$router.push('/wishlist');
    },
    goToAnalytics() {
      this.$router.push('/analytics');
    },
    goToSettings() {
      this.$router.push('/settings');
    },
    goToAdmin() {
      this.$router.push('/admin');
    },
    goToLogin() {
      this.$router.push('/login');
    },
    goToRegister() {
      this.$router.push('/register');
    },

    // ========== 消息通知相关方法 ==========
    
    // 获取用户消息列表
    async loadMessages() {
      if (!this.isLoggedIn) return;
      
      try {
        const response = await axios.get('api/messages/', {
          withCredentials: true
        });
        
        if (response.data.success) {
          this.messageList = response.data.data;
          this.unreadMessageCount = response.data.unread_count;
        }
      } catch (err) {
        console.error('获取消息失败:', err);
      }
    },
    
    // 关闭消息弹窗
    closeMessageModal() {
      this.showMessageModal = false;
    },
    
    // 阅读消息
    async readMessage(msg) {
      if (!msg.is_read) {
        try {
          await axios.post(`api/messages/${msg.id}/read/`, {}, {
            withCredentials: true
          });
          msg.is_read = true;
          this.unreadMessageCount = Math.max(0, this.unreadMessageCount - 1);
        } catch (err) {
          console.error('标记已读失败:', err);
        }
      }
    },
    
    // 标记所有消息为已读
    async markAllMessagesRead() {
      try {
        await axios.post('api/messages/read-all/', {}, {
          withCredentials: true
        });
        
        // 更新本地状态
        this.messageList.forEach(msg => {
          msg.is_read = true;
        });
        this.unreadMessageCount = 0;
        
        this.$message.success('所有消息已标记为已读');
      } catch (err) {
        console.error('标记全部已读失败:', err);
        this.$message.error('操作失败');
      }
    },
    
    // 启动消息轮询
    startMessagePolling() {
      // 如果已经在轮询中，先停止之前的
      if (this.messagePollingInterval) {
        this.stopMessagePolling();
      }
      
      // 立即加载一次
      this.loadMessages();
      
      // 每30秒轮询一次
      this.messagePollingInterval = setInterval(() => {
        this.loadMessages();
      }, 30000);
    },
    
    // 停止消息轮询
    stopMessagePolling() {
      if (this.messagePollingInterval) {
        clearInterval(this.messagePollingInterval);
        this.messagePollingInterval = null;
      }
    },

    // 启动用户数动态增长
    startUserCountGrowth() {
      // 每天随机增加1-10
      const ONE_DAY = 24 * 60 * 60 * 1000; // 24小时
      const randomIncrement = () => Math.floor(Math.random() * 10) + 1; // 1-10

      const grow = () => {
        this.displayUserCount += randomIncrement();
        // 设置下一次增长（每天）
        this.userCountInterval = setTimeout(grow, ONE_DAY);
      };

      // 首次延迟启动（1天后）
      this.userCountInterval = setTimeout(grow, ONE_DAY);
    },

    // ========== 问题反馈相关方法 ==========
    
    // 关闭反馈弹窗
    closeFeedbackModal() {
      this.showFeedbackModal = false;
      this.feedbackContent = '';
      this.feedbackContact = '';
      this.feedbackImages = [];
    },
    
    // 提交问题反馈
    async submitFeedback() {
      if (!this.feedbackContent.trim()) {
        this.$message.error('请输入反馈内容');
        return;
      }
      
      this.isSubmittingFeedback = true;
      
      try {
        const response = await axios.post('api/feedback/', {
          content: this.feedbackContent,
          contact: this.feedbackContact,
          images: this.feedbackImages
        }, {
          withCredentials: true
        });
        
        if (response.data.success) {
          this.$message.success('反馈提交成功，我们会尽快处理');
          this.closeFeedbackModal();
        } else {
          this.$message.error(response.data.error || '提交失败');
        }
      } catch (err) {
        console.error('提交反馈失败:', err);
        this.$message.error('提交失败，请稍后重试');
      } finally {
        this.isSubmittingFeedback = false;
      }
    },
    
    // 处理反馈图片粘贴
    handleFeedbackPaste(e) {
      const items = e.clipboardData.items;
      
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          const blob = items[i].getAsFile();
          const reader = new FileReader();
          
          reader.onload = (event) => {
            if (this.feedbackImages.length < 5) {
              this.feedbackImages.push(event.target.result);
            } else {
              this.$message.warning('最多只能添加5张图片');
            }
          };
          
          reader.readAsDataURL(blob);
        }
      }
    },
    
    // 移除反馈图片
    removeFeedbackImage(index) {
      this.feedbackImages.splice(index, 1);
    },
    
    // 聚焦图片区域
    focusImageArea() {
      this.$refs.feedbackImageArea?.focus();
      this.$message.info('请按 Ctrl+V 粘贴图片');
    },

    // 触发文件选择
    triggerFeedbackFileInput() {
      if (this.feedbackImages.length >= 5) {
        this.$message.warning('最多只能添加5张图片');
        return;
      }
      this.$refs.feedbackFileInput?.click();
    },

    // 处理文件选择
    handleFeedbackFileSelect(e) {
      const files = e.target.files;
      if (!files || files.length === 0) return;

      const remainingSlots = 5 - this.feedbackImages.length;
      const filesToProcess = Math.min(files.length, remainingSlots);

      if (files.length > remainingSlots) {
        this.$message.warning(`最多还能添加${remainingSlots}张图片`);
      }

      for (let i = 0; i < filesToProcess; i++) {
        const file = files[i];
        if (!file.type.startsWith('image/')) {
          this.$message.warning(`${file.name} 不是图片文件，已跳过`);
          continue;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
          this.feedbackImages.push(event.target.result);
        };
        reader.readAsDataURL(file);
      }

      // 清空input，允许重复选择同一文件
      e.target.value = '';
    },
    
    // 预览反馈图片
    previewFeedbackImage(url) {
      this.previewImageUrl = url;
    },

    // 提交修改密码
    async submitChangePassword() {
      // 验证密码
      if (!this.newPassword || this.newPassword.length < 6) {
        this.$message.error('密码长度至少6位');
        return;
      }

      if (this.newPassword !== this.confirmNewPassword) {
        this.$message.error('两次输入的密码不一致');
        return;
      }

      try {
        const response = await axios.post('api/set-password/', {
          password: this.newPassword,
          confirm_password: this.confirmNewPassword
        }, {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });

        if (response.data.success) {
          this.$message.success('密码设置成功！下次可用手机号和密码登录');
          this.showChangePasswordModal = false;
          this.newPassword = '';
          this.confirmNewPassword = '';
        } else {
          this.$message.error(response.data.error || '设置失败');
        }
      } catch (err) {
        console.error('设置密码失败:', err);
        this.$message.error(err.response?.data?.error || '设置失败，请稍后重试');
      }
    },

    // 重复查询
    repeatSearch(search) {
      console.log('重复查询:', search);
      // 实现重复查询的逻辑
    },
    
    // 退出登录
    // logout() {
    //   const csrftoken = getCookie('csrftoken');
      
    //   // 使用绝对路径代替相对路径，确保在任何环境下都能正确请求
    //   axios.post('/api/logout/', {}, {
    //     withCredentials: true, // 确保跨域请求时也能发送cookie
    //     headers: { 
    //       'X-Csrftoken': csrftoken 
    //     }
    //   })
    //   .then(() => {
    //     // 使用 Vuex mutation 清除状态
    //     this.$store.commit('SET_USER', {
    //       isLoggedIn: false,
    //       username: '',
    //       isSuperAdmin: '用户'
    //     });
    //     // 跳转到首页
    //     this.$router.push('/');
    //   })
    //   .catch(error => {
    //     console.error('退出登录失败:', error);
    //     // 即使API调用失败，也清除本地状态
    //     this.$store.commit('SET_USER', {
    //       isLoggedIn: false,
    //       username: '',
    //       isSuperAdmin: '用户'
    //     });
    //     this.$router.push('/');
    //   });
    // }
    // 退出登录
    logout() {
      // 发送退出请求到后端
      axios.post('api/logout/')
        .then(() => {
          // 使用 Vuex mutation 清除状态
          this.$store.commit('SET_LOGIN_STATUS', {
            isLoggedIn: false,
            username: '',
            isSuperAdmin: '用户',
            isStaff: false,
            role: '用户'
          });
          
          // 清除本地存储
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('user');
          
          // 跳转到首页
          this.$router.push('/');
        })
        .catch(error => {
          console.error('退出登录失败:', error);
          // 即使出错，也清除前端状态
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('user');
          this.$store.commit('SET_LOGIN_STATUS', {
            isLoggedIn: false,
            username: '',
            isSuperAdmin: '用户',
            isStaff: false,
            role: '用户'
          });
          
          this.$router.push('/');
        });
    },
  }
}
</script>

<style scoped>
.dashboard-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #4a67fb;
  color: white;
}

.auth-buttons {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.auth-btn {
  padding: 5px 15px;
  background-color: #0482ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.auth-btn:hover {
  background-color: #66b1ff;
}

/* 消息按钮样式和悬停效果 */
.dashboard-page .message-feedback-group .auth-btn.message-btn {
  position: relative;
  transition: background-color 0.3s ease;
}

.dashboard-page .message-feedback-group .auth-btn.message-btn:hover {
  background-color: #42A5F5 !important;
}

/* 问题反馈按钮样式和悬停效果 */
.dashboard-page .message-feedback-group .auth-btn.feedback-btn {
  transition: background-color 0.3s ease;
}

.dashboard-page .message-feedback-group .auth-btn.feedback-btn:hover {
  background-color: #ffb74d !important;
}

/* 院校库专业库按钮悬停效果 */
.dashboard-page .majors-btn:hover {
  background-color: #66b1ff !important;
}

.dashboard-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.dashboard-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.card-header h3 {
  margin: 0 0 10px 0;
  color: #333;
}

.card-content {
  text-align: center;
}

.card-value {
  font-size: 32px;
  font-weight: bold;
  color: #4a67fb;
  margin-bottom: 5px;
}

.card-description {
  color: #666;
  font-size: 14px;
}

.quick-actions, .recent-searches, .popular-majors {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 30px;
}

.quick-actions h2, .recent-searches h2, .popular-majors h2 {
  margin: 0 0 20px 0;
  color: #333;
}

.action-buttons {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}

.action-btn {
  padding: 15px;
  background-color: #4a67fb;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.action-btn:hover {
  background-color: #3a57eb;
}

/* 快捷操作中专业库按钮的hover效果 - 覆盖内联样式 */
.dashboard-page .action-buttons .action-btn[style*="409EFF"]:hover {
  background-color: #66b1ff !important;
}

.search-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.search-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 5px;
}

.search-info {
  display: flex;
  gap: 15px;
}

.search-date {
  color: #666;
  font-size: 14px;
}

.search-keyword {
  font-weight: bold;
  color: #333;
}

.search-btn {
  padding: 5px 15px;
  background-color: #4a67fb;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.major-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
}

.major-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 5px;
  border-left: 4px solid #4a67fb;
}

.major-name {
  font-weight: bold;
  color: #333;
}

.major-rank {
  background-color: #4a67fb;
  color: white;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;
}

.no-data {
  text-align: center;
  color: #999;
  padding: 20px;
}

.footer {
  text-align: center;
  padding: 20px 0;
  background-color: #f5f5f5;
  margin-top: 20px;
  color: #888;
}
/* 新增样式 */
.activation-section {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.card-input {
  flex: 1;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.vip-info {
  background-color: #f9f9f9;
  padding: 10px;
  border-radius: 4px;
}

.vip-info p {
  margin: 5px 0;
}

/* 激活按钮样式 - 与输入框同高 */
.btn-activate {
  height: 40px;
  padding: 0 30px;
  background: linear-gradient(135deg, #ff5722 0%, #ff7043 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 12px rgba(255, 107, 53, 0.4);
}

.btn-activate:hover {
  background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(255, 107, 53, 0.3);
}

.btn-activate:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(255, 107, 53, 0.3);
}

/* 高考年份设置样式 */
.gaokao-year-display {
  font-weight: bold;
  color: #4a67fb;
  font-size: 16px;
  margin-right: 8px;
}

.gaokao-year-hint {
  color: #888;
  font-size: 14px;
}

.gaokao-year-tip {
  color: #ff6b35;
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 0;
}

/* 弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* ========== 消息通知样式 ========== */

.message-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #f44336;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 12px;
  min-width: 18px;
  text-align: center;
}

/* 用户身份角标样式 */
.user-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: linear-gradient(135deg, #FFD700, #FFA500);
  color: #fff;
  border-radius: 10px;
  padding: 1px 6px;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* VIP角标样式 - 用于快捷操作按钮 */
.vip-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: linear-gradient(135deg, #FFD700, #FFA500);
  color: #fff;
  border-radius: 10px;
  padding: 1px 6px;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.message-modal-container {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.message-item.unread {
  background-color: #f0f7ff;
}

/* ========== 反馈弹窗样式 ========== */
.feedback-modal-container {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.feedback-modal-container h3 {
  margin: 0 0 10px 0;
  color: #333;
  text-align: center;
  font-size: 20px;
}

.feedback-modal-container .modal-desc {
  color: #666;
  font-size: 14px;
  text-align: center;
  margin-bottom: 25px;
}

.feedback-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.feedback-form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.feedback-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  display: flex;
  align-items: center;
  gap: 4px;
}

.feedback-label .required {
  color: #f44336;
}

.feedback-label .optional {
  color: #999;
  font-weight: normal;
  font-size: 13px;
}

.feedback-textarea,
.feedback-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
  transition: border-color 0.3s;
}

.feedback-textarea:focus,
.feedback-input:focus {
  outline: none;
  border-color: #4a67fb;
}

.feedback-textarea {
  resize: vertical;
  min-height: 100px;
}

/* 图片上传区域样式 */
.image-upload-wrapper {
  display: flex;
  align-items: stretch;
  gap: 10px;
}

.image-upload-area {
  flex: 1;
  border: 2px dashed #ddd;
  border-radius: 6px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-image-btn {
  width: 100px;
  min-width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px;
  background-color: #f5f7fa;
  border: 2px solid #e4e7ed;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 13px;
  color: #606266;
}

.upload-image-btn:hover {
  background-color: #ecf5ff;
  border-color: #4a67fb;
  color: #4a67fb;
}

.upload-image-btn span:first-child {
  font-size: 24px;
}

.image-upload-area:hover,
.image-upload-area:focus {
  border-color: #4a67fb;
  outline: none;
}

.upload-placeholder {
  color: #999;
}

.upload-placeholder p {
  margin: 5px 0;
}

.image-preview-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

.image-preview-item {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #ddd;
}

.image-preview-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}

.remove-image-btn {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 20px;
  height: 20px;
  background-color: rgba(244, 67, 54, 0.9);
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-more-images {
  width: 80px;
  height: 80px;
  border: 2px dashed #ddd;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #999;
  transition: border-color 0.3s;
}

.add-more-images:hover {
  border-color: #4a67fb;
  color: #4a67fb;
}

.add-more-images span {
  font-size: 24px;
  line-height: 1;
}

.add-more-images p {
  margin: 5px 0 0 0;
  font-size: 12px;
}

.image-count-hint {
  font-size: 12px;
  color: #666;
  margin: 5px 0 0 0;
}

/* 反馈弹窗按钮 */
.feedback-modal-buttons {
  display: flex;
  gap: 12px;
  margin-top: 25px;
}

.feedback-btn-cancel,
.feedback-btn-confirm {
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s;
}

.feedback-btn-cancel {
  background-color: #f0f0f0;
  color: #666;
}

.feedback-btn-cancel:hover {
  background-color: #e0e0e0;
}

.feedback-btn-confirm {
  background-color: #4a67fb;
  color: white;
}

.feedback-btn-confirm:hover:not(:disabled) {
  background-color: #3a57eb;
}

.feedback-btn-confirm:disabled {
  background-color: #a5b4fc;
  cursor: not-allowed;
}

.modal-container h3 {
  margin: 0 0 10px 0;
  color: #333;
  text-align: center;
}

.modal-desc {
  color: #666;
  font-size: 14px;
  text-align: center;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  color: #333;
  font-size: 14px;
}

.form-input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-input:focus {
  border-color: #4a67fb;
  outline: none;
}

.modal-buttons {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.btn-cancel, .btn-confirm {
  flex: 1;
  padding: 10px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-cancel {
  background-color: #f0f0f0;
  color: #666;
}

.btn-cancel:hover {
  background-color: #e0e0e0;
}

.btn-confirm {
  background-color: #4a67fb;
  color: white;
}

.btn-confirm:hover {
  background-color: #3a57eb;
}

/* 小屏设备优化 */
@media (max-width: 768px) {
  /* 标题单独一行，按钮在下一行 */
  .dashboard-page .page-header {
    flex-direction: column !important;
    align-items: center !important;
    gap: 10px !important;
  }

  .dashboard-page .page-header h1 {
    width: 100% !important;
    font-size: 18px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    text-align: center !important;
  }

  /* 按钮容器 - 四列两行布局（有管理员后台时） */
  .dashboard-page .page-header > div {
    display: grid !important;
    grid-template-columns: repeat(4, 1fr) !important;
    grid-template-rows: repeat(2, 1fr) !important;
    gap: 8px !important;
    width: 100% !important;
    justify-items: stretch !important;
    align-items: stretch !important;
  }

  /* 管理员后台按钮 - 第一列跨两行 */
  .dashboard-page .page-header > div > button:first-child {
    grid-column: 1 / 2 !important;
    grid-row: 1 / 3 !important;
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
  }

  /* 志愿查询按钮 - 第一行第二列 */
  .dashboard-page .page-header > div > button:nth-of-type(2) {
    grid-column: 2 / 3 !important;
    grid-row: 1 !important;
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
  }

  /* 专业库按钮 - 第二行第二列 */
  .dashboard-page .page-header > div > button:nth-of-type(3) {
    grid-column: 2 / 3 !important;
    grid-row: 2 !important;
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
  }

  /* 专业库按钮悬停效果 */
  .dashboard-page .page-header > div > button:nth-of-type(3):hover {
    background-color: #66b1ff !important;
  }

  /* 消息按钮 - 第一行第三列 */
  .dashboard-page .message-feedback-group .message-btn {
    grid-column: 3 / 4 !important;
    grid-row: 1 !important;
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
  }

  /* 问题反馈按钮 - 第二行第三列 */
  .dashboard-page .message-feedback-group .feedback-btn {
    grid-column: 3 / 4 !important;
    grid-row: 2 !important;
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
  }

  /* 消息反馈组重置为contents */
  .dashboard-page .message-feedback-group {
    display: contents !important;
  }

  /* 用户名/登录按钮 - 第一行第四列 */
  .dashboard-page .page-header > div > div:nth-of-type(2) .auth-btn:first-child,
  .dashboard-page .page-header > div > div:nth-of-type(3) .auth-btn:first-child {
    grid-column: 4 / 5 !important;
    grid-row: 1 !important;
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
  }

  /* 退出/注册按钮 - 第二行第四列 */
  .dashboard-page .page-header > div > div:nth-of-type(2) .auth-btn:last-child,
  .dashboard-page .page-header > div > div:nth-of-type(3) .auth-btn:last-child {
    grid-column: 4 / 5 !important;
    grid-row: 2 !important;
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
  }

  /* 登录注册组重置为contents */
  .dashboard-page .page-header > div > div:nth-of-type(2),
  .dashboard-page .page-header > div > div:nth-of-type(3) {
    display: contents !important;
  }

  /* 消息按钮悬停效果 */
  .dashboard-page .message-feedback-group .message-btn:hover {
    background-color: #42A5F5 !important;
  }

  /* 问题反馈按钮悬停效果 */
  .dashboard-page .message-feedback-group .feedback-btn:hover {
    background-color: #ffb74d !important;
  }
}
</style>
